import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import { callApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
// import { TZ_CONFIG } from '../../../constants/tz-config'

const mapStateToProps = (state, ownProps) => {
    return {
        roles: state.roles,
        account: state.account,
        user: state.user
    }
}

const CreateUser = ({ dispatch, navigate, params, user, roles, account }) => {
    const accountId = account.id

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('roles', 'LIST')))
    }, [dispatch])


    const submitFX = (formData, formId) => {
        formData.accountId = accountId
        dispatch(callApi(apiResourceEndpoint('members', 'CREATE'), formData, formId))
    }

    const successFX = (userId) => {
        navigate(buildRoutePath(routes.appTeamMemberView.path, { accountId, userId }))
    }

    const roleOptions = roles.slice()
        .sort((a, b) => {
            if (a.level > b.level) {
                return -1
            }
            return 1
        })
        .map(role => ({ value: role.id, label: role.name }))

    return (
        <div className="app-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Create New User</h1>
                        <p>Use the form below to create and add a new user to your team.</p>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box editable">
                        {(user._computed.roleLevel <= 100) ? (
                            <h1>You do not have permission to view this page.</h1>
                        ) : (
                            <SHSForm
                                extraClass="flex-form"
                                showCancel={true}
                                cancelAction={() => navigate(buildRoutePath(routes.appTeamIndex.path, { accountId }))}
                                submitFX={submitFX}
                                successFX={successFX}>
                                <InputElement
                                    type="text"
                                    id="firstName"
                                    label="First Name"
                                    placeholder="John"
                                    extraClass="flex-33"
                                    required />
                                <InputElement
                                    type="text"
                                    id="lastName"
                                    label="Last Name"
                                    placeholder="Doe"
                                    extraClass="flex-33"
                                    required />
                                <InputElement
                                    type="email"
                                    id="email"
                                    label="Email"
                                    placeholder="user@domain.com"
                                    extraClass="flex-50"
                                    required />
                                <InputElement
                                    type="text"
                                    id="password"
                                    label="Password"
                                    placeholder="myPassword123"
                                    extraClass="flex-50"
                                    required />
                                <InputElement
                                    type="valueSelect"
                                    id="roleId"
                                    label="Role"
                                    options={roleOptions}
                                    extraClass="flex-50"
                                    required />
                            </SHSForm>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(CreateUser))
